<script setup lang="ts">
import { computed } from "vue";
import { AnnuitiesPremium } from "../entities/premium";

const props = defineProps<{quotations: AnnuitiesPremium[], numberOfPossibleQuotes: number }>();

const percentageLoading = computed(() => {
    const percentage = (props.quotations?.length / props.numberOfPossibleQuotes) * 100;
    return (percentage > 100) ? 100 : percentage;
});

</script>

<template>
    <div
        class="get-quotes-bar mt-4 mb-4"
    >
        <div class="progress mb-4">
            <div
                class="progress-bar bg-info-slide"
                :style="`width: ${percentageLoading}%`"
            />
        </div>
        <div class="row">
            <div class="col-12">
                <p class="text-center chalet loading-title">
                    Loading your Annuity Quotes...
                </p>
            </div>
        </div>
    </div>
</template>
<style scoped>
.get-quotes-bar{
        position: relative;
        z-index: 2;
    }
.logo {
    max-width: 20rem;
}

.loading-title {
    font-weight: 600;
    font-size: 1.5rem;
    color: #494949;
    padding-bottom: 20px;
}
</style>
